import { sectionRenderer } from '@theme/section-renderer';
const DLN_GIFT_VARIANT_ID = 59016977875276;
const DLN_CART_SECTION_ID = 'cart-drawer-section';

let dlnGiftBusy = false;
let dlnGiftTimer = null;

function dlnRoot() {
  return window.Shopify?.routes?.root || '/';
}

function dlnScheduleGiftSync(delay = 250) {
  clearTimeout(dlnGiftTimer);
  dlnGiftTimer = setTimeout(dlnSyncGift, delay);
}

async function dlnGetCart() {
  const response = await fetch(`${dlnRoot()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Could not read cart');
  return response.json();
}

async function dlnAddGift() {
  const response = await fetch(`${dlnRoot()}cart/add.js`, {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: DLN_GIFT_VARIANT_ID, quantity: 1, properties: { _dln_free_gift: 'true' } }] }),
  });
  if (!response.ok) throw new Error('Could not add gift');
}

async function dlnChangeGift(lineKey, quantity) {
  const response = await fetch(`${dlnRoot()}cart/change.js`, {
    method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity }),
  });
  if (!response.ok) throw new Error('Could not update gift');
}

async function dlnRefreshDrawer() {
  const pageCart = document.querySelector('main cart-items-component[data-section-id]');
  if (pageCart) {
    await sectionRenderer.renderSection(pageCart.dataset.sectionId, { cache: false, mode: 'full' });
    return;
  }
  const response = await fetch(`${dlnRoot()}?section_id=${DLN_CART_SECTION_ID}`, { credentials: 'same-origin' });
  if (!response.ok) return;
  const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
  const incoming = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
  const current = document.querySelector('#cart-drawer [data-hydration-key="cart-drawer-inner"]');
  if (incoming && current) current.replaceWith(incoming);
}

async function dlnSyncGift() {
  if (dlnGiftBusy) return;
  dlnGiftBusy = true;
  try {
    const cart = await dlnGetCart();
    const gifts = cart.items.filter((item) => Number(item.variant_id) === DLN_GIFT_VARIANT_ID);
    const normalItems = cart.items.filter((item) => Number(item.variant_id) !== DLN_GIFT_VARIANT_ID);
    let changed = false;

    if (normalItems.length && !gifts.length) {
      await dlnAddGift(); changed = true;
    } else if (!normalItems.length && gifts.length) {
      for (const gift of gifts) await dlnChangeGift(gift.key, 0);
      changed = true;
    } else if (gifts.length) {
      if (gifts[0].quantity !== 1) { await dlnChangeGift(gifts[0].key, 1); changed = true; }
      for (const gift of gifts.slice(1)) { await dlnChangeGift(gift.key, 0); changed = true; }
    }

    if (changed) await dlnRefreshDrawer();
  } catch (error) {
    console.warn('[DLN] Free gift sync skipped:', error);
  } finally {
    dlnGiftBusy = false;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => dlnScheduleGiftSync(100), { once: true });
} else {
  dlnScheduleGiftSync(100);
}

// Re-check after cart interactions and common Horizon cart events.
document.addEventListener('click', (event) => {
  const el = event.target instanceof Element ? event.target : null;
  if (el?.closest('button, [role="button"], a[href*="/cart"]')) dlnScheduleGiftSync(800);
}, true);

document.addEventListener('change', (event) => {
  const el = event.target instanceof Element ? event.target : null;
  if (el?.closest('cart-items-component, .cart-form')) dlnScheduleGiftSync(800);
}, true);

document.addEventListener('cart:update', () => dlnScheduleGiftSync(150));
document.addEventListener('cart:updated', () => dlnScheduleGiftSync(150));

